import { PerspectiveCamera } from "@react-three/drei";
import { Scene } from "../../Types";
import { useSceneStore } from "../../api/Zustand";
import { useZoomStore } from "../../state management/zustand/common-stores";

const Camera = (props: { zoom?: number; scene?: Scene }) => {
  const { scene: currentScene } = useSceneStore();

  const { zoom } = useZoomStore();

  const scene = props.scene || currentScene;

  return (
    <PerspectiveCamera
      makeDefault
      fov={props.zoom ?? zoom}
      position={[
        Math.sin(((scene?.rotation || 0) / 180) * Math.PI),
        0,
        -Math.cos(((scene?.rotation || 0) / 180) * Math.PI),
      ]}
    />
  );
};

export default Camera;
